export { default as InfoLabel } from "./InfoLabel";
export * from "./InfoLabel";
